import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=1104204d&scoped=true&class=fill-height&"
import script from "./EditTaskModal.vue?vue&type=script&lang=ts&"
export * from "./EditTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=1104204d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1104204d",
  null
  
)

export default component.exports